export function RoundContainer({ children, className, ...props }) {
    return (
        <div className={`flex items-center justify-center rounded-full  ${className}`} {...props} >
            {children}
        </div>

    )
}
